<script lang="ts">
    import type { LocationListEntry } from "../../../../../../admin-service-typescript-client";

    export let location: LocationListEntry;
    export let selectCallback: () => void;
    console.log(location);
</script>

<tr on:click={selectCallback}>
    <td>{location.address.addressLine1}</td>
    <td>
        {location.address.city}
    </td>
    <td>{location.address.postalCode}</td>
    <td>{location.active ? "aktiv" : "inaktiv"}</td>
</tr>

<style>
    td {
        text-align: center !important;
    }

    tr:hover {
        cursor: pointer;
    }
</style>
